import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestArqueacoes({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'arqueacoes', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) {
      erros.map((error) => toast.error(error));
    } else {
      toast.error(erros);
    }
  }
}

export function* deleteArqueacao({ payload }) {
  try {
    const { idarqueacao, params } = payload;

    yield call(api.delete, `arqueacoes/${idarqueacao}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) {
      erros.map((error) => toast.error(t(error)));
    } else {
      toast.error(t(erros));
    }
  }
}

export function* store({ payload }) {
  try {
    const { arqueacao, params } = payload;

    yield call(api.post, 'arqueacoes', arqueacao);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/arqueacoes');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) {
      erros.map((error) => toast.error(error));
    } else {
      toast.error(erros);
    }
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `arqueacoes/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) {
      erros.map((error) => toast.error(error));
    } else {
      toast.error(erros);
    }
  }
}

export function* update({ payload }) {
  try {
    const { arqueacao, params } = payload;

    yield call(api.put, 'arqueacoes', arqueacao);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/arqueacoes');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) {
      erros.map((error) => toast.error(error));
    } else {
      toast.error(erros);
    }
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'arqueacoes', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) {
      erros.map((error) => toast.error(error));
    } else {
      toast.error(erros);
    }
  }
}

export default all([
  takeLatest('@arqueacoes/ARQUEACOES_IN_REQUEST', requestArqueacoes),
  takeLatest('@arqueacoes/DELETE_ARQUEACAO', deleteArqueacao),
  takeLatest('@arqueacoes/SUCCESS_REMOVE', requestArqueacoes),
  takeLatest('@arqueacoes/STORE_ARQUEACAO', store),
  takeLatest('@arqueacoes/FIND_ARQUEACAO', find),
  takeLatest('@arqueacoes/UPDATE_ARQUEACAO', update),
  takeLatest('@arqueacoes/RECORD_FILTERING', applyedFilters),
]);
